import * as React from 'react';
import styled from 'styled-components';

import {ProgressIndicator} from '../account/_components/ProgressIndicator';
import {RegisterBrandPanel} from './RegisterBrandPanel';
import {RegisterFormContext} from './RegisterForm.context';
import {STEPS, stepDefinition} from './RegisterForm.steps';

const Grade = styled.div`
  display: grid;
  grid-template-columns: 48% 52%;
  min-height: 100vh;

  /* Abaixo de 1024px o formulario vem primeiro: quem abre no celular veio
     preencher, nao ler a apresentacao. */
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;

const Marca = styled.div`
  display: flex;
  /* Item de grid/flex nao encolhe abaixo do proprio conteudo sem isto, e no
     celular o painel (conteudo + padding) empurrava a pagina para os lados. */
  min-width: 0;

  /* Sem isto o painel azul para na altura do texto e sobra branco embaixo. */
  > * {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 1023px) {
    order: 2;
  }
`;

const Coluna = styled.main`
  background: #fff;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: 1023px) {
    order: 1;
    padding: 24px 18px 40px;
  }
`;

const Conteudo = styled.div`
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const Contador = styled.p`
  margin: 0;
  font-size: 13px;
  color: #5b6b7c;
`;

const Entrar = styled.p`
  margin-top: 32px;
  font-size: 14px;
  color: #5b6b7c;

  a {
    color: #006bf3;
    font-weight: 600;
  }
`;

interface Props {
  logoUrl?: string;
  children: React.ReactNode;
}

export const RegisterShell: React.FC<Props> = ({logoUrl, children}) => {
  const {step, watch} = React.useContext(RegisterFormContext);
  const passo = stepDefinition(step);
  const avatarPreview = watch('avatar_preview');
  const nome = watch('name');

  return (
    <Grade>
      <Marca>
        <RegisterBrandPanel step={step} logoUrl={logoUrl} avatarUrl={avatarPreview} nome={nome} />
      </Marca>

      <Coluna>
        <Conteudo>
          <Contador>
            Passo {step} de {STEPS.length} — {passo.label}
          </Contador>

          <ProgressIndicator
            currentStep={passo.key}
            steps={STEPS.map(({key, label}) => ({key, label}))}
            ariaLabel="Progresso do cadastro"
            colors={{primary: '#006bf3'}}
          />

          {children}

          <Entrar>
            Já tem conta? <a href="/users/sign_in">Entrar</a>
          </Entrar>
        </Conteudo>
      </Coluna>
    </Grade>
  );
};
